// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"838":"de30ff1a8385c13f","920":"03a222f10fe23ce6","944":"31a6c13d241137c1"}[chunkId] + ".js";
};